import {
  //
  ADD_BLOGS,
  ADD_BLOGS_FAILURE,
  ADD_BLOGS_SUCCESS,
  //
  DELETE_BLOGS,
  DELETE_BLOGS_FAILURE,
  DELETE_BLOGS_SUCCESS,
  //
  EDIT_BLOGS,
  EDIT_BLOGS_FAILURE,
  EDIT_BLOGS_SUCCESS,
  //
  FETCH_BLOGS,
  FETCH_BLOGS_FAILURE,
  FETCH_BLOGS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
} from "./constants";

// List
export const fetchBlogs = (payload) => ({
  type: FETCH_BLOGS,
  payload,
});
export const fetchBlogsSuccess = (payload) => ({
  type: FETCH_BLOGS_SUCCESS,
  payload,
});
export const fetchBlogsFailure = (payload) => ({
  type: FETCH_BLOGS_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addBlogs = (payload) => ({
  type: ADD_BLOGS,
  payload,
});
export const addBlogsSuccess = (payload) => ({
  type: ADD_BLOGS_SUCCESS,
  payload,
});
export const addBlogsFailure = (payload) => ({
  type: ADD_BLOGS_FAILURE,
  payload,
});
// EDIT
export const editBlogs = (payload) => ({
  type: EDIT_BLOGS,
  payload,
});
export const editBlogsSuccess = (payload) => ({
  type: EDIT_BLOGS_SUCCESS,
  payload,
});
export const editBlogsFailure = (payload) => ({
  type: EDIT_BLOGS_FAILURE,
  payload,
});
// DELETE
export const deleteBlogs = (payload) => ({
  type: DELETE_BLOGS,
  payload,
});
export const deleteBlogsSuccess = (payload) => ({
  type: DELETE_BLOGS_SUCCESS,
  payload,
});
export const deleteBlogsFailure = (payload) => ({
  type: DELETE_BLOGS_FAILURE,
  payload,
});
